const BlueLine = () => {
    return(
        <div style={{width: "100%", height:"13px", backgroundColor:"#03244D"}}>
        </div>
    )
};

export default BlueLine;